<template>
<div class="content-login">
    <v-card
    class="mx-auto my-auto text-left rounded-0 card-login"
    max-width="600"
    min-width="450"
  >
    <v-card-text>
      <div class="logo">PrimeCMS</div>
      <p class="login-text">
        Espace Administrateur
      </p>
      <p>
          Veillez entrer votre email pour pouvoir vous identifier.
      </p>
      <v-text-field
        value=""
        label="Email"
        v-model="email"
        outlined
      ></v-text-field>
    </v-card-text>
    <v-card-actions class="text-right">
      <v-btn
        outlined
        icon
        color="gray"
        @click="goback"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        dark
        color="primary accent-4"
        outlined
        @click="reset"
      >
        Continuer
      </v-btn>
    </v-card-actions>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      right
      top
      multi-line
      app
    >
      {{snackbarText}}
      <v-btn
        text
        dark
        @click="snackbar = false"
      >
        Fermer
      </v-btn>
    </v-snackbar>
  </v-card>
</div>
</template>
<script>

export default {
  name: 'reset-login',
  data: () => ({
      email: '',
      password: '',
      color: 'error',
      snackbar: false,
      snackbarText: ""
  }),
  mounted(){
    if(this.$store.getters.isLoggedIn){
      this.$store.dispatch('logout')
    }
  },
  methods: {
      goback(){
        this.$router.push({name: 'login'})
      },
      reset(){
          var email = {email: this.email}
          this.axios.post('../user/reset/password', email).then((res) => {
              
            if(res.data.error === false){
              this.color = "success"
              this.snackbar = true
              this.snackbarText = "Le lien de récupération de votre mot de passe a été envoyé à votre e-mail, expire dans 15 minutes."
            }else{
                if(res.data.reset_code_exists){
                    this.color = "error"
                    this.snackbar = true
                    this.snackbarText = "Un code de récupération de votre compte a été trouvé, veuillez vérifier dans votre boite de récéption e-mail."
                }else{
                    this.color = "error"
                    this.snackbar = true
                    this.snackbarText = "Aucun utilisateur n'est lié à cette adresse email, veuillez verifier."
                }
              
            }
            
          }).catch(e => {
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Un erreur est survenu, essayez plus tard."
            console.log(e)
          })
      }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat&family=Raleway:wght@400;700&display=swap');
.content-login{
  height:100%;
  background: url('https://i.imgur.com/JFYas77.png') no-repeat bottom right;
  background-size:900px;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  position: relative;
}
* {
  font-family: "Raleway", sans-serif;
}
.card-login {
  box-shadow: 0 20px 40px rgba(0,0,0,0.2) !important;
  padding: 60px 20px;
}
.login-text{
  font-size:12px;
  margin: 0 15px;
  margin-bottom:25px;
  margin-left:15px;
  display:block;
}
.logo {
  font-family: 'Raleway', sans-serif;
  letter-spacing: -1px;
  font-size: 24px;
  font-weight: 700;
  margin-left: 15px;
  text-align: left;
  background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/login/reset.vue